// Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Types
import { VisualAcuityChartRowType } from "src/services/exams/types";

type VisualAcuityScaleType = {
  chartRow: VisualAcuityChartRowType;
  isLiveUpdate?: boolean;
};

const VisualAcuityScale = ({
  chartRow,
  isLiveUpdate = false,
}: VisualAcuityScaleType) => {
  // Smaller text on narrow screens in the live update view, so the
  // Feet/Metres values fit without ellipsis-truncating as aggressively.
  const fontSize = isLiveUpdate ? { xs: "11px", sm: "14px" } : "14px";

  return (
    <Grid item display="flex" alignItems="center" xs={3} sx={{ minWidth: 0 }}>
      <Grid item xs={6} textAlign="center" sx={{ minWidth: 0 }}>
        <Typography noWrap fontSize={fontSize} textAlign="center">
          {chartRow?.snellenVisualAcuityScaleFeet ?? "-"}
        </Typography>
      </Grid>
      <Grid item xs={6} textAlign="center" sx={{ minWidth: 0 }}>
        <Typography noWrap fontSize={fontSize} textAlign="center">
          {chartRow?.snellenVisualAcuityScaleMetres ?? "-"}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default VisualAcuityScale;
